// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-24pp8";
var _4 = "content-2u7IO";
var _5 = "root_transfer-3oK3x";
var _6 = "root__scrollBody-1SDd5";
var _7 = "root__paper-3ut_c";
var _8 = "root_animal-2IKDW";
var _9 = "modal__closeButton-fg8-e";
var _a = "root_businessLounge-2thcM";
var _b = "header-ZikDP";
var _c = "root_priorityBoarding-3ZblF";
var _d = "root_loyalty-1UQE2";
var _e = "root_upgrade-3vt8k";
var _f = "root_misc-21Mib";
var _10 = "header__info-1mGVZ";
var _11 = "header__icon-UAutJ";
var _12 = "root_insurance-39Af3";
var _13 = "root_baggageDelivery-iKwC7";
var _14 = "root_capsuleHotel-aXcL0";
var _15 = "root_sms-3Yc50";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "content", _5 as "root_transfer", _6 as "root__scrollBody", _7 as "root__paper", _8 as "root_animal", _9 as "modal__closeButton", _a as "root_businessLounge", _b as "header", _c as "root_priorityBoarding", _d as "root_loyalty", _e as "root_upgrade", _f as "root_misc", _10 as "header__info", _11 as "header__icon", _12 as "root_insurance", _13 as "root_baggageDelivery", _14 as "root_capsuleHotel", _15 as "root_sms" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "content": _4, "root_transfer": _5, "root__scrollBody": _6, "root__paper": _7, "root_animal": _8, "modal__closeButton": _9, "root_businessLounge": _a, "header": _b, "root_priorityBoarding": _c, "root_loyalty": _d, "root_upgrade": _e, "root_misc": _f, "header__info": _10, "header__icon": _11, "root_insurance": _12, "root_baggageDelivery": _13, "root_capsuleHotel": _14, "root_sms": _15 }
